import { render } from "./impersonationForm.vue?vue&type=template&id=c0b20862&scoped=true&ts=true"
import script from "./impersonationForm.vue?vue&type=script&lang=ts"
export * from "./impersonationForm.vue?vue&type=script&lang=ts"

import "./impersonationForm.vue?vue&type=style&index=0&id=c0b20862&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b20862"]])

export default __exports__